<!--   平台运维-企业套餐 -->
<template>
  <div class="mainArea BusinessPlan">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 搜索框 -->
        <div class="searchBox">
          <el-input
            class="searchInput"
            placeholder="请输入企业名称"
            v-model="planData.paging.search_str"
            clearable>
          </el-input>
          <el-button
            class="searchBtn"
            type="primary"
            @click="getPlanList('search')">搜 索</el-button>
        </div>

        <!--企业信息table-->
        <div class="planListTable">
          <el-table
            v-loading="planData.loading"
            :data="planData.list"
            :cell-style="setCellStyle"
            style="width: 96%">
            <el-table-column
              type="index"
              label="序号"
              width="80">
            </el-table-column>
            <el-table-column
              prop="company_name"
              label="企业名称">
            </el-table-column>
            <el-table-column
              prop="use_date"
              label="使用期限">
            </el-table-column>
            <el-table-column
              prop="platform_fee"
              label="平台使用费用"
              width="120">
            </el-table-column>
            <el-table-column
              prop="sms_fee_t"
              label="短信费用"
              width="120">
            </el-table-column>
            <el-table-column
              prop="sms_total_amount"
              label="短信条数"
              width="120">
              <template slot-scope="scope">
                {{scope.row.sms_total_amount === null ? '/' : scope.row.sms_total_amount}}
              </template>
            </el-table-column>
            <el-table-column
              prop="fourg"
              label="4G路由"
              width="120">
            </el-table-column>
            <el-table-column
              label="是否欠费"
              width="120">
              <template slot-scope="scope">
                <el-button type="text" @click="operateUserInfo('changeStatus',scope.row)">{{ scope.row.available_flag === '1' ? '否' : '是'}}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="150">
              <template slot-scope="scope">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="operateUserInfo('alter', scope.row)">修改</el-dropdown-item>
                    <el-dropdown-item @click.native="operateUserInfo('payDes', scope.row)">付费详情</el-dropdown-item>
                    <el-dropdown-item @click.native="operateUserInfo('prestore', scope.row)">预存</el-dropdown-item>
                    <el-dropdown-item @click.native="operateUserInfo('billInfo', scope.row.ticket_info)">开票信息</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-button type="text" @click="operateUserInfo('alter', scope.row)">修改</el-button>
                <el-button type="text" @click="operateUserInfo('payDes', scope.row)">付费详情</el-button>
                <el-button type="text" @click="operateUserInfo('prestore', scope.row)">预存</el-button>
                <el-button type="text" @click="operateUserInfo('billInfo', scope.row.ticket_info)">开票信息</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <div class="paging" v-if="planData.paging.pageCount > 1">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="planData.paging.page"
            layout="prev, pager, next, jumper"
            :page-count="planData.paging.pageCount">
          </el-pagination>
        </div>

        <!--对话框-->
        <el-dialog
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">
          
          <!-- 欠费状态 -->
          <div
            class="changeStatusWrapper"
            v-if="dialogData.type === 'changeStatus'">
            <p class="text">
              当前企业为
              <span class="bold">
                {{dialogData.info.available_flag === '1' ? '未欠费' : '欠费'}}
              </span>
            </p>
            <p class="text">
              修改为
              <span class="bold">
                {{dialogData.info.available_flag === '1' ? '欠费' : '未欠费'}}？
              </span>
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="changePlanStatus()">确 认</el-button>
            </div>
          </div>

          <!-- 预存 -->
          <div
            v-else-if="dialogData.type === 'prestore'">
            <el-form
              class="perstoreForm"
              label-width="100px"
              :model="prestoreData">
              <el-form-item label="预存类型:">
                <div class="inputBox">
                  <el-radio v-model="prestoreData.type" label="1">平台使用费</el-radio>
                  <el-radio v-model="prestoreData.type" label="2">短信充值费</el-radio>
                </div>
              </el-form-item>
              <el-form-item label="预存金额:">
                <div class="inputBox">
                  <el-input class="money" v-model="prestoreData.money"></el-input> 元
                </div>
              </el-form-item>
              <el-form-item label="是否付费:">
                <div class="inputBox">
                  <el-radio v-model="prestoreData.pay_status" label="1">已付费</el-radio>
                  <el-radio v-model="prestoreData.pay_status" label="0">未付费</el-radio>
                </div>
              </el-form-item>     
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button @click="confirmPrestore()">是</el-button>
            </div>
          </div>

          <!-- 付费详情 -->
          <div
            class="payDesBox"
            v-else-if="dialogData.type === 'payDes'">
            <p class="companyName">企业名称：{{dialogData.info.company_name}}</p>
            <!-- tab -->
            <el-tabs v-model="payDesData.postData.type">
              <el-tab-pane label="平台使用费" name="1"></el-tab-pane>
              <el-tab-pane label="短信服务费" name="2"></el-tab-pane>
            </el-tabs>
            <!-- 付费详情列表 -->
            <el-table
              v-loading="payDesData.loading"
              :data="payDesData.payLogList"
              style="width: 96%">
              <el-table-column
                prop="pay_time"
                label="充值时间">
              </el-table-column>
              <el-table-column
                prop="money"
                label="充值金额">
              </el-table-column>
              <el-table-column
                prop="operator_user"
                label="操作人">
              </el-table-column>
              <el-table-column
                prop="bill_flag"
                label="开具发票需求">
              </el-table-column>
              <el-table-column
                label="是否付费">
                <template slot-scope="scope">
                  <el-button type="text" @click="operatePayLog('pay',scope.row)">{{ scope.row.pay_status === '1' ? '是' : '否' }}</el-button>
                </template>
              </el-table-column>
              <el-table-column
                label="是否开具发票">
                <template slot-scope="scope">
                  <el-button type="text" @click="operatePayLog('bill',scope.row)">{{ scope.row.had_bill === '1' ? '已开具' : '未开具' }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 付费详情分页 -->
            <div class="paging" v-if="payDesData.pageCount > 1">
              <el-pagination
                @current-change="payDesHandleCurrentChange"
                :current-page.sync="payDesData.postData.page"
                layout="prev, pager, next, jumper"
                :page-count="payDesData.pageCount">
              </el-pagination>
            </div>
            <!-- 付费详情 对话框 -->
             <el-dialog
              class="payDesDialog"
              :title="payDesData.dialogData.title" 
              :visible.sync="payDesData.dialogData.visible"
              :show-close="payDesData.dialogData.title === '' ? false : true">

              <!-- 状态 -->
              <div
                class="changeStatusWrapper">
                <p class="text">
                  修改为
                  <!-- 支付 -->
                  <span class="bold" v-if="payDesData.dialogData.type === 'pay'">
                  {{ payDesData.dialogData.pay_status === '1' ? '未支付' : '已支付' }}
                  </span>
                  <!-- 是否开具发票 -->
                  <span class="bold" v-else>
                  {{ payDesData.dialogData.had_bill === '1' ? '未开具' : '已开具' }}
                  </span>
                </p>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="payDesData.dialogData.visible = false">取 消</el-button>
                  <el-button @click="changePayStatus()">确认</el-button>
                </div>
              </div>

            </el-dialog>
          </div>

          <!-- 开票信息 -->
          <div
            v-else-if="dialogData.type === 'billInfo'">
            <ul class="billList">
              <li class="sTitle">开票资质信息</li>
              <li class="li clearfix">
                <span class="left">纳税人识别号</span>
                <span class="right">{{dialogData.info.user_no}}</span>
              </li>
              <li class="li clearfix">
                <span class="left">开户行</span>
                <span class="right">{{dialogData.info.user_card_name}}</span>
              </li>
              <li class="li clearfix">
                <span class="left">银行账号</span>
                <span class="right">{{dialogData.info.user_card_no}}</span>
              </li>
              <li class="li clearfix">
                <span class="left">电话</span>
                <span class="right">{{dialogData.info.user_phone}}</span>
              </li>
              <li class="li clearfix">
                <span class="left">地址</span>
                <span class="right">{{dialogData.info.user_address}}</span>
              </li>
            </ul>
            <ul class="billList">
              <li class="sTitle">邮寄信息</li>
              <li class="li clearfix">
                <span class="left">收件人</span>
                <span class="right">{{dialogData.info.post_user_name}}</span>
              </li>
              <li class="li clearfix">
                <span class="left">联系人</span>
                <span class="right">{{dialogData.info.post_user_phone}}</span>
              </li>
              <li class="li clearfix">
                <span class="left">邮件地址</span>
                <span class="right">{{dialogData.info.post_user_address}}</span>
              </li>
              <li class="li clearfix">
                <span class="left">邮政编码</span>
                <span class="right">{{dialogData.info.post_user_zip_code}}</span>
              </li>
            </ul>
          </div>

          <!-- 添加或修改企业套餐信息 -->
          <div v-else>
            <el-form
              class="alterForm"
              label-width="100px"
              :model="dialogData.info">
              <el-form-item label="企业名称:">
                <div class="inputBox">
                  <el-input class="name" v-model="dialogData.info.company_name" readonly></el-input>
                </div>
              </el-form-item>
              <el-form-item label="使用期限:">
                <div class="inputBox">
                  <el-date-picker
                    class="datePicker"
                    v-model="dialogData.info.date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="平台使用费用:">
                <div class="inputBox feeBox clearfix">
                  <el-select
                    class="feeType"
                    placeholder="请选择"
                    v-model="dialogData.info.fee_type">
                    <el-option
                      v-for="item in feeTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-input class="fee" v-model="dialogData.info.fee"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="短信:">
                <div class="inputBox smsBox">
                  <el-checkbox class="smsFlag" v-model="dialogData.info.sms_flag">使用短信</el-checkbox>
                  <span v-if="dialogData.info.sms_flag">费率：<el-input class="smsFee" v-model="dialogData.info.sms_fee" ></el-input>  元/条</span>
                </div>
              </el-form-item>
              <el-form-item label="4G路由:">
                <div class="inputBox">
                  <el-checkbox v-model="dialogData.info.fourg_flag">使用路由</el-checkbox>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="confirmUpdatePlan()">确 认</el-button>
            </div>
          </div>
        </el-dialog>


      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../../Layout/BreadCrumb.vue"
  import {
      showToast
    } from "../../../../../static/js/utility/utility.js"
    
  import { 
      getNowDate
    } from "../../../../../static/js/utility/date.js"
  import { maintainApi } from "../../../../../static/js/api.js"

  export default {
    name: 'BusinessPlan',
    components: {
      BreadCrumb
    }, 
    data() {
      return {
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 企业列表数据
        planData: {
          // 分页数据  page为当前页，perPage为每页数量 ,search_str为搜索字段
          paging: {
            page: 1,
            perPage: 10,
            search_str: ''
          },
          // 企业列表
          list: [],
          loading: false
        },
        // 预存数据
        prestoreData: {
          type: '1',
          money: '',
          pay_status: '0'
        },
        // 付费详情请求data
        payDesData: {
          // 付费详情列表
          payLogList: [],
          loading: false,
          // 付费详情请求data
          postData: {
            page: 1,
            perPage: 10,
            type: '1'
          },
          // 付费详情dialog
          dialogData: {
            type: '',
            title: '',
            visible: false,
            info: {}
          }
        },
        // 平台费用类型列表
        feeTypeList: [
          {
            label: '年',
            value: '1'
          },
          {
            label: '季度',
            value: '2'
          },
          {
            label: '月',
            value: '3'
          },
        ],
      }
    },
    mounted(){
      this.getPlanList()
    },
    created: async function () {
    },
    methods: {
      // 设置单元格样式，使用期限小于一个月
      setCellStyle: function ({row, column, rowIndex, columnIndex}) {
        // console.log('row.days', row.days)
        // console.log('column', column)
        // console.log('rowIndex', rowIndex)
        // console.log('columnIndex', columnIndex)
        if (row.days < 31 && columnIndex === 2) {
          return {color: '#F23A3A'}
        } else {
          return ''
        }
      },
      // 计算时间差,天数
      computedDays: function (startDate, endDate) {
        // new Date(s1.replace(/-/g, "/"))
        var value=new Date(endDate.replace(/-/g, "/")).getTime() - new Date(startDate.replace(/-/g, "/")).getTime()  //时间差的毫秒数
        //计算出相差天数
        var days=Math.floor(value/(24*3600*1000))
        console.log('days', days)
        return days
      },
      // 当前页值改变，获取新的客户列表
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.getPlanList()
      },
      // 处理企业套餐列表数据
      processData: function (data) {
        let vm = this
        let list = data.list
        for (let i in list) {
          list[i].use_date = data.list[i].start_date + '~' + data.list[i].end_date
          list[i].platform_fee = data.list[i].fee === null ? '/' : data.list[i].fee + '/' + (data.list[i].fee_type === '1' ? '年' : data.list[i].fee_type === '2' ? '季度' : '月' )
          list[i].sms_fee_t = data.list[i].sms_fee === null ? '/' : data.list[i].sms_fee + '/条'
          list[i].fourg = data.list[i].fourg_available_amount + '/' + data.list[i].fourg_total_amount
          list[i].days = vm.computedDays(data.list[i].start_date, data.list[i].end_date)
        }

        vm.planData.list = list
        vm.planData.paging.pageCount = data.pageCount
        
        console.log('企业套餐列表', vm.planData.list)
      },
      // 获取企业套餐列表
      getPlanList: async function (isSearch) {
        // console.log('12', this.planData.paging.search_str)
        let vm = this
        let data = vm.planData.paging
        // 搜索列表，page默认为1
        if (isSearch) {
          data.page = '1' 
        } 

        console.log('this.paging', data)

        vm.planData.loading = true
        let res = await maintainApi.getPlanList(data)
        vm.planData.loading = false
        if (res.meta.code === 200) {
          console.log('res.data', res.data)
          vm.processData(res.data)
        } else {
          showToast(res.meta.message)
        }
      },
      // 操作企业套餐信息（添加或修改）dialogData
      operateUserInfo: function (type, info) {
        let newInfo = {}
        console.log('type', type)
        console.log('info', info)
        // return
        if (type === 'alter') {
          newInfo = {
            company_id: info.company_id,
            company_name: info.company_name,
            date: [info.start_date === null ? '' : info.start_date, info.end_date === null ? '' : info.end_date],
            fee_type: info.fee_type,
            fee: info.fee,
            sms_flag: info.sms_flag === '1' ? true : false,
            fourg_flag: info.fourg_flag === '1' ? true : false,
            sms_fee: info.sms_fee
          }
        }
        this.dialogData = {
          type: type,
          title: type === 'changeStatus' ? '修改欠费状态' : type === 'alter' ? '修改企业套餐' : type === 'prestore' ? '预存' : type === 'payDes' ? '付费详情' : '开票信息',
          visible: !(this.dialogData.visible),
          info: type === 'alter' ? newInfo : info ? info : ''
        }
        console.log('this', this.dialogData)

        // type为payDes，需获取付费详情列表
        if (type === 'payDes') {
          this.getPayLogList()
        }
      },
      // 操作付费详情信息 dialogData
      operatePayLog: function (type, info) {
        this.payDesData.dialogData = {
          type: type,
          title: type === 'pay' ? '修改付费状态' : '修改开票状态',
          visible: !(this.payDesData.dialogData.visible),
          info: info
        }
        console.log('二级this', this.payDesData.dialogData)
      },
      // 修改付费详情支付状态和开票状态
      changePayStatus: async function () {
        let vm = this
        let data = {
          id: vm.payDesData.dialogData.info.order_id,
          action: vm.payDesData.dialogData.type
        }
        console.log('data', data)

        let res = await maintainApi.changePayStatus(data)
        if (res.meta.code === 200) {
          vm.payDesData.dialogData.visible = !(vm.payDesData.dialogData.visible)
          showToast('修改成功')
          vm.getPayLogList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 付费详情当前页值改变，获取新的付费详情列表
      payDesHandleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.getPayLogList()
      },
      // 处理付费详情数据
      processPayLogData: function (data) {
        let vm = this
        let payLogList = data.list
        console.log('data', data)
        for (let i in payLogList) {
          payLogList[i].bill_flag = data.list[i].bill_flag === '1' ? '需要' : '不需要'
        }

        vm.payDesData.payLogList = payLogList
        vm.payDesData.pageCount = data.pageCount
      },
      // 获取付费详情列表
      getPayLogList: async function () {
        let vm = this
        let data = vm.payDesData.postData
        data.company_id = vm.dialogData.info.company_id
        // console.log('付费详情data', data)

        vm.payDesData.loading = true
        let res = await maintainApi.getPayLogList(data)
        vm.payDesData.loading = false
        if (res.meta.code === 200) {
          console.log('付费详情列表', res.data)
          vm.processPayLogData(res.data)
        } else {
          showToast(res.meta.message)
        }
      },
      // 预存
      confirmPrestore: async function () {
        let vm = this
        let data = vm.prestoreData
        data.company_id = vm.dialogData.info.company_id

        // 已付费需，需输入预存金额
        if (data.money === '') {
          showToast('请输入预存金额！')
          return
        }
        console.log('预存data', data)

        let res = await maintainApi.prestore(data)
        if (res.meta.code === 200) {
          this.dialogData.visible = !(this.dialogData.visible)
          showToast('预存修改成功')
          vm.getPlanList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 修改企业套餐欠费状态
      changePlanStatus: async function () {
        let vm = this
        let data = {
          company_id: vm.dialogData.info.company_id
        }
        let res = await maintainApi.changePlanStatus(data)
        if (res.meta.code === 200) {
          this.dialogData.visible = !(this.dialogData.visible)
          showToast('修改成功')
          vm.getPlanList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 确认修改企业套餐
      confirmUpdatePlan: function () {
        let vm = this
        let data = {
          company_id: vm.dialogData.info.company_id,
          start_date: getNowDate(vm.dialogData.info.date[0]),
          end_date: getNowDate(vm.dialogData.info.date[1]),
          fee_type: vm.dialogData.info.fee_type,
          fee: vm.dialogData.info.fee,
          sms_flag: vm.dialogData.info.sms_flag ? '1' : '0',
          fourg_flag: vm.dialogData.info.fourg_flag ? '1' : '0',
          sms_fee: vm.dialogData.info.sms_fee
        }
        // 判断值
        if (data.start_date === '' || data.end_date === '') {
          showToast('时间期限不能为空！')
          return false
        }
        if (data.fee_type === null || data.fee === null) {
          showToast('平台使用费用不能为空！')
          return false
        }
        if (data.sms_flag === '1') {
          if (data.sms_fee === null) {
            showToast('短信费用不能为空！')
            return false
          }
        }

        console.log('修改date', data)
        // return
        vm.updatePlan(data)
      },
      // 修改企业套餐
      updatePlan: async function (data) {
        let vm = this

        let res = await maintainApi.updatePlan(data)
        if (res.meta.code === 200) {
          showToast('修改成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getPlanList()
        } else {
          showToast(res.meta.message)
        }
        console.log('res', res)
      }
    },
    watch: {
      // 监听搜索字段，清空更新企业列表
      'planData.paging.search_str': function (newVal) {
        if (newVal === '') {
          this.getPlanList()
        }
        console.log('tag', this.planData.paging.search_str)
      },
      // 监听付费详情切换tab，获取新的付费详情列表
      'payDesData.postData.type': function (newVal) {
        console.log('新tab', newVal)
        this.getPayLogList()
      },
      // 监听预存付费状态，未付费，金额为0
      'prestoreData.pay_status': function (newVal) {
        console.log('预存付费状态', newVal)
        if (newVal === '0') {
          this.prestoreData.money = 0
        }
      },
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    },
    props: []
  }
</script>

<style lang="scss" scoped>
.searchBox {
  margin-bottom: 20px;
  .searchInput {
    width: 30%;
    margin-right: 10px;
  }
}

  // 修改企业套餐
  .alterForm {
    .inputBox.feeBox{
      width: 350px;
      .feeType, .fee {
        width: 160px;
        float: left;
      }
      .feeType {
        margin-right: 30px;
      }
    }
    .inputBox.smsBox {
      width: 350px;
      line-height: 40px;
      .smsFlag {
        line-height: 40px;
        margin-right: 30px;
      }
      .smsFee {
        width: 150px;
      }
    }
  }

  // 预存
  .perstoreForm {
    .money {
      width: 200px;
      margin-right: 5px;
    }
  }

  // 开票信息
  .billList {
    padding: 0 30px;
    margin-bottom: 20px;
    font-size: 14px;
    .sTitle {
      line-height: 30px;
      margin-bottom: 10px;
      color: #000000;
      border-bottom: 1px dashed #cccccc;
    }
    .li {
      height: 40px;
      line-height: 40px;
      // margin-bottom: 10px;
      span{
        float: left;
        height: 40px;
        line-height: 40px;
      }
      .left {
        width: 120px;
        color: #898989;
        text-align: right;
        margin-right: 5px;
      }
      .right {
        width: 300px;
        color: #565656;
        text-indent: 1em;
        border-bottom: 1px solid #C0C0C0;
      }
    }
  }

  // 付费详情
  .payDesBox {
    .companyName {
      margin-bottom: 10px;
    }
  }

  .colorRed {
    color: red;
  }


</style>



// WEBPACK FOOTER //
// src/components/Page/Maintain/BusinessPlan/SIndex.vue